export default __webpack_public_path__ + "ab1d89c59b5cc15427351dfbf744eaf3.svg";